import superagent from '@ott/superagent';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RequestError } from '../../types';
import prepareQuery from '../../helpers/prepareQuery';
import { RequestResponse, Payload } from './types';

export const refillCard = createAsyncThunk<RequestResponse, Payload, { rejectValue: RequestError }>(
  'virtualCard/refillCard/fetch',
  async (payload, { rejectWithValue }) => {
    try {
      const url = '/_virtual_cards/abb/replenish';
      const params = prepareQuery();

      const {
        body: { error, result },
      } = await superagent.post(url).query(params).send(payload);

      if (error) {
        throw error;
      }

      return result as RequestResponse;
    } catch (error: any) {
      return rejectWithValue(error.response.body as RequestError);
    }
  }
);
